import { useRef, useState } from "react";

export default function useDebouncedState<T>(initialValue: T, timeoutMs = 500) {
    const timeoutId = useRef<NodeJS.Timeout>(undefined);

    const [immediateState, setImmediateState] = useState(initialValue);
    const [delayedState, setDelayedState] = useState(immediateState);

    const setStateDebounced = (value: T) => {
        if (undefined !== timeoutId.current) {
            clearTimeout(timeoutId.current as unknown as number);
        }

        setImmediateState(value);
        timeoutId.current = setTimeout(() => setDelayedState(value), timeoutMs);
    };

    return [immediateState, delayedState, setStateDebounced] as const;
}
